const MEMBER_TYPE_OPTIONS = {
  NEW_MEMBER: 'new-member',
  FROM_TEAM: 'from-team',
} as const

type memberType = (typeof MEMBER_TYPE_OPTIONS)[keyof typeof MEMBER_TYPE_OPTIONS]

export { type memberType, MEMBER_TYPE_OPTIONS }
